import { useCallback, useState } from 'react'
import { ChangeUsersApiHandler } from '../types'
import { userService } from '../services'
import { useToast } from '@celebration/react'
import { getMessageFromApiError } from '../../../api/utils'
import { ApiError } from '../../../api/types'
import { UserRoles } from '../../auth/types'

const useUsersApi = (): ChangeUsersApiHandler => {
  const [isLoading, setIsLoading] = useState(false)
  const { openToast } = useToast()
  const changeUserProfile = useCallback(async (role: string) => {
    setIsLoading(true)
    try {
      const entries = Object.entries(UserRoles)
      const newRole = entries.find((entry) => entry[1] === role)
      if (!newRole) {
        openToast({
          title: 'Erro ao alterar perfil do usuário',
          description: 'Perfil inválido',
          type: 'negative',
        })
        return
      }
      await userService.changeUserProfile(newRole[0])
    } catch (error) {
      openToast({
        title: 'Erro ao alterar perfil do usuário',
        description: getMessageFromApiError(error as ApiError),
        type: 'negative',
      })
    } finally {
      setIsLoading(false)
    }
  }, [openToast])
  return { isLoading, changeUserProfile }
}

export default useUsersApi
